module.exports = __webpack_public_path__ + "static/media/Froakie_gaussian2.4602599a.png";